// src/hooks/useThemeColors.js
import { useGetThemeDataQuery } from '../../Services/vehicle/Vehicle';

const themeColors = {
  blue: "#F25D21",
  purple: "#F25D21",
  pantone: "#F25D21",
  orange: "#F25D21",
};

const themeBackgroundColors = {
  blue: "#F8E9E3",
  purple: "#F8E9E3",
  pantone: "#F8E9E3",
  orange: "#F8E9E3",
};

const themeBorderColors = {
  blue: "#F25D21",
  purple: "#F25D21",
  pantone: "#F25D21",
  orange: "#F25D21",
};

const buttonBackgroundColors = {
  orange: "#F25D21"
};

const buttonColors = {
  orange: "#FFFFFF"
}

const useThemeColors = () => {
  const { data: themeData } = useGetThemeDataQuery({});

  const selectedTheme = themeData?.selected_theme;

  const selectedColor = themeColors[selectedTheme] || "#F25D21";
  const selectedBackgroundColor = themeBackgroundColors[selectedTheme] || "#F8E9E3";
  const selectedBorderColor = themeBorderColors[selectedTheme] || "#F25D21";
  const selectedButtonBackgoundColors = buttonBackgroundColors[selectedTheme] || "#F25D21"
  const selectedButtonColors = buttonColors[selectedTheme] || "#FFFFFF"

  return { selectedColor, selectedBackgroundColor, selectedBorderColor, selectedButtonBackgoundColors , selectedButtonColors};
};

export default useThemeColors;
